<template>
  <div id="app">
    <router-view name='comheader'></router-view>
    <router-view/>
    <router-view name='comfooter'></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;height:100%;
}
*{margin: 0;padding: 0;}
a{text-decoration: none;}
span{cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/App.vue